import { createApi } from '@reduxjs/toolkit/query/react';

import { NOTIFICATION_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

const TagType = { WATCHES: 'WATCHES' };

/** Allowlisted watch resource kinds (mirrors notification-svc Resource). */
export const WatchResources = {
    TREATMENT: 'treatment',
    PATIENT: 'patient',
};

const mapWatch = (watch) => ({
    watchId: watch.watch_id,
    resource: watch.resource,
    resourceId: watch.resource_id,
    cohortId: watch.cohort_id,
    patientFirstName: watch.patient_first_name,
    patientLastName: watch.patient_last_name,
    productServiceOid: watch.product_service_oid,
    payerId: watch.payer_id,
    kafkaTopics: watch.kafka_topics ?? [],
    createdAt: watch.created_at,
});

export const notificationApi = createApi({
    baseQuery: getBaseQuery(NOTIFICATION_API_URL),
    refetchOnMountOrArgChange: true,
    reducerPath: 'notificationApi',
    tagTypes: Object.values(TagType),
    endpoints: (build) => ({
        getWatches: build.query({
            query: () => 'watches',
            transformResponse: (response) => (response ?? []).map(mapWatch),
            providesTags: [TagType.WATCHES],
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving resource watches.',
            ),
        }),
        upsertWatch: build.mutation({
            query: (body) => ({
                url: 'watches',
                method: 'POST',
                body,
            }),
            transformResponse: mapWatch,
            invalidatesTags: (_, error) => (!error ? [TagType.WATCHES] : undefined),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred saving the resource watch.',
            ),
        }),
        unwatch: build.mutation({
            query: (watchId) => ({
                url: `watches/${watchId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_, error) => (!error ? [TagType.WATCHES] : undefined),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred unsubscribing from the resource watch.',
            ),
        }),
    }),
});

export const { useGetWatchesQuery, useUpsertWatchMutation, useUnwatchMutation } = notificationApi;
